import React, { ReactElement } from 'react'
import { InputLabelProps, TextField, TextFieldProps, styled } from '@mui/material'
import { TEXT_FIELD_DEFAULT_STYLE } from 'src/ui-shared/base/form/control/TextField.style'

const StyledTextFieldDefault = styled(TextField)(() => ({
  ...TEXT_FIELD_DEFAULT_STYLE,
}))

export const TextFieldDefault = (props: TextFieldProps): ReactElement => {
  const inputLabelProps = props.slotProps?.inputLabel as InputLabelProps | undefined

  return (
    <StyledTextFieldDefault
      {...props}
      variant={props.variant || 'filled'}
      fullWidth={props.fullWidth || true}
      slotProps={{
        ...props.slotProps,
        inputLabel: {
          ...inputLabelProps,
          shrink: inputLabelProps?.shrink ?? true,
        },
      }}
    />
  )
}
